import type { User } from '@supabase/supabase-js';
import { supabase } from './supabase';

// Dispara o evento de "primeiro login" no servidor. A Edge Function decide
// (via email_log) se o welcome será enviado de fato — chamar em todo SIGNED_IN
// é seguro e idempotente.
export async function triggerFirstLoginEmail(user: User): Promise<void> {
  try {
    await supabase.functions.invoke('on-first-login', {
      body: { user_id: user.id },
    });
  } catch (err) {
    // Não bloqueia o app — e-mail é best-effort.
    if (typeof console !== 'undefined') {
      console.warn('triggerFirstLoginEmail failed', err);
    }
  }
}

// Chamado após upsert de sticker quando floor(percentage/25) muda. A Edge
// Function valida no servidor (não confia no cliente) e dispara o e-mail.
export async function triggerMilestoneCheck(userId: string, percentage: number): Promise<void> {
  try {
    await supabase.functions.invoke('check-milestones', {
      body: { user_id: userId, percentage },
    });
  } catch (err) {
    if (typeof console !== 'undefined') {
      console.warn('triggerMilestoneCheck failed', err);
    }
  }
}
